import { render, staticRenderFns } from "./AboutProgram.vue?vue&type=template&id=32390614&"
import script from "./AboutProgram.vue?vue&type=script&lang=js&"
export * from "./AboutProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports